// ================= НАСТРОЙКИ =================
var DEV_DOMAIN = process.env.VUE_APP_DEV_DOMAIN;

// Проверка: является ли текущая среда продакшеном
var currentHost = window.location.hostname;
var isDevEnv = currentHost === DEV_DOMAIN || currentHost.includes('www.' + DEV_DOMAIN);

// Если нужно отключить функционал вручную для тестов, просто поставьте здесь true:
// var isProdEnv = true;
// =============================================
var container = document.querySelector('.container');

if (!isDevEnv) {
  const switcher = document.querySelector('.bg-switcher')
  if (switcher) switcher.style.display = 'none';

  // Прерываем выполнение всего остального кода ниже
  container.dataset.bg = 'summer';
}else {
  var select = document.getElementById('bgSelect');
  var nextBtn = document.getElementById('bgNext');
  var prevBtn = document.getElementById('bgPrev');

  var options = Array.prototype.slice.call(select.options).map(function(o){ return o.value; });
  var STORAGE_KEY = 'login:bg';

  function apply(bg) {
    container.dataset.bg = bg;
    select.value = bg;
    try { localStorage.setItem(STORAGE_KEY, bg); } catch (e) {}
  }

  // init from localStorage, else from data-bg, else first option
  var saved = null;
  try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}
  var initial = saved || container.dataset.bg || options[0];
  if (options.indexOf(initial) === -1) initial = options[0];
  apply(initial);

  select.addEventListener('change', function () {
    apply(select.value);
  });

  nextBtn.addEventListener('click', function () {
    var current = container.dataset.bg || options[0];
    var idx = options.indexOf(current);
    var next = options[(idx + 1) % options.length];
    apply(next);
  });

  prevBtn.addEventListener('click', function () {
    var current = container.dataset.bg || options[0];
    var idx = options.indexOf(current);
    if (idx < 0) idx = 0;

    var prevIdx = (idx - 1 + options.length) % options.length;
    var prev = options[prevIdx];

    apply(prev);
  });
}
